import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { IconContext } from "react-icons";

import { App } from "./app";
import PrimeProvider from "./config/prime/PrimeProvider";
import { NotificationContainer } from "./features/notifications";
import "./styles/index.css";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "always",
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      networkMode: "always",
    },
  },
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <PrimeProvider>
      <QueryClientProvider client={queryClient}>
        <IconContext.Provider value={{ size: "1.5rem" }}>
          <App />
          <NotificationContainer />
        </IconContext.Provider>
      </QueryClientProvider>
    </PrimeProvider>
  </StrictMode>,
);
